import { useEffect, useState } from 'react'
import axios from 'axios'
import { ShieldCheck, UsersRound } from 'lucide-react'
import PageHeader from '../components/PageHeader'
import { boardMemberImage, type BoardMember } from '../types/Board'

const Board = () => {
  const [members, setMembers] = useState<BoardMember[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    axios.get<BoardMember[]>('/api/board')
      .then(({ data }) => setMembers(data))
      .catch(() => setError(true))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div className="space-y-8">
      <PageHeader
        eyebrow="Notre équipe"
        title="Le bureau du club"
        description="Découvrez les bénévoles qui font vivre le Taï-Jitsu Drômois et accompagnent le club au quotidien."
        icon={<UsersRound />}
      />

      {loading ? (
        <div className="board-status">Chargement du bureau…</div>
      ) : error ? (
        <div className="board-status board-status-error">Impossible de charger le bureau pour le moment.</div>
      ) : members.length === 0 ? (
        <div className="empty-state"><ShieldCheck className="mx-auto mb-4 h-10 w-10 text-emerald-600" /><h2>Le bureau sera bientôt présenté ici</h2></div>
      ) : (
        <section className="board-grid" aria-label="Membres du bureau">
          {members.map((member) => {
            const image = boardMemberImage(member)
            const initials = `${member.user.firstName.charAt(0)}${member.user.lastName.charAt(0)}`
            return (
              <article className="board-card" key={member.id}>
                <div className="board-portrait">
                  {image ? <img src={image} alt={`${member.user.firstName} ${member.user.lastName}`} /> : <span aria-hidden="true">{initials}</span>}
                </div>
                <div className="board-card-copy">
                  <p>{member.role}</p>
                  <h2>{member.user.firstName} {member.user.lastName}</h2>
                </div>
              </article>
            )
          })}
        </section>
      )}
    </div>
  )
}

export default Board
